import { getTopStores } from '../endpoints';
import { FeaturedStoresVariables } from '../types/IStoreBySlugQueryDTO';

export const getFeaturedStores = async (variables?: FeaturedStoresVariables) => {
  const { storeId, categoryId } = variables || {};
  const response = await getTopStores.requestAsPromise({ storeId, categoryId });
  return response.data;
}
